interface IGetPageCountParams {
    totalResults?: number;
    recordsPerPage?: number;
}

export const getPageCount = (params: IGetPageCountParams) => {
    if (!params.totalResults || !params.recordsPerPage) {
        return 1;
    }

    return Math.ceil(params.totalResults / params.recordsPerPage);
};
interface IGetPageCountParams {
    totalResults?: number;
    recordsPerPage?: number;
}

export const getPageCount = (params: IGetPageCountParams) => {
    if (!params.totalResults || !params.recordsPerPage) {
        return 1;
    }

    return Math.ceil(params.totalResults / params.recordsPerPage);
};
